import styled from 'styled-components';

import { media } from '../Dashboard/media';

const H3 = styled.h3`
  margin: 0;
  padding: 0;

  font-size: 18px;
  line-height: auto;

  @media (min-width: ${media.large}) {
    font-size: 24px;
  }
`;

export default H3;
